export const PERMISSIONS = {
	ALL: "all",

	VIEW_DASHBOARD: "VIEW_DASHBOARD",

	VIEW_PROPERTIES: "VIEW_PROPERTIES",

	VIEW_ROLE: "VIEW_ROLE",
	ADD_ROLE: "ADD_ROLE",
	EDIT_ROLE: "EDIT_ROLE",
	DELETE_ROLE: "DELETE_ROLE",
	IMPORT_ROLE: "IMPORT_ROLE",
	EXPORT_ROLE: "EXPORT_ROLE",
	ACCEPT_ROLE: "ACCEPT_ROLE",

	VIEW_USER: "VIEW_USER",
	ADD_USER: "ADD_USER",
	EDIT_USER: "EDIT_USER",
	DELETE_USER: "DELETE_USER",
	IMPORT_USER: "IMPORT_USER",
	EXPORT_USER: "EXPORT_USER",
	ACCEPT_USER: "ACCEPT_USER",

	VIEW_CUSTOMER: "VIEW_CUSTOMER",
	ADD_CUSTOMER: "ADD_CUSTOMER",
	EDIT_CUSTOMER: "EDIT_CUSTOMER",
	DELETE_CUSTOMER: "DELETE_CUSTOMER",
	IMPORT_CUSTOMER: "IMPORT_CUSTOMER",
	EXPORT_CUSTOMER: "EXPORT_CUSTOMER",
	ACCEPT_CUSTOMER: "ACCEPT_CUSTOMER",

	VIEW_CATEGORY: "VIEW_CATEGORY",
	ADD_CATEGORY: "ADD_CATEGORY",
	EDIT_CATEGORY: "EDIT_CATEGORY",
	DELETE_CATEGORY: "DELETE_CATEGORY",
	EXPORT_CATEGORY: "EXPORT_CATEGORY",
	ACCEPT_CATEGORY: "ACCEPT_CATEGORY",

	VIEW_MAP: "VIEW_MAP",
	ADD_MAP: "ADD_MAP",
	EDIT_MAP: "EDIT_MAP",
	DELETE_MAP: "DELETE_MAP",
	IMPORT_MAP: "IMPORT_MAP",
	EXPORT_MAP: "EXPORT_MAP",
	ACCEPT_MAP: "ACCEPT_MAP",

	VIEW_APPRAISE: "VIEW_APPRAISE",
	ADD_APPRAISE: "ADD_APPRAISE",
	EDIT_APPRAISE: "EDIT_APPRAISE",
	DELETE_APPRAISE: "DELETE_APPRAISE",
	IMPORT_APPRAISE: "IMPORT_APPRAISE",
	EXPORT_APPRAISE: "EXPORT_APPRAISE",
	ACCEPT_APPRAISE: "ACCEPT_APPRAISE",

	VIEW_CERTIFICATE: "VIEW_CERTIFICATE",
	ADD_CERTIFICATE: "ADD_CERTIFICATE",
	EDIT_CERTIFICATE: "EDIT_CERTIFICATE",
	DELETE_CERTIFICATE: "DELETE_CERTIFICATE",
	IMPORT_CERTIFICATE: "IMPORT_CERTIFICATE",
	EXPORT_CERTIFICATE: "EXPORT_CERTIFICATE",
	ACCEPT_CERTIFICATE: "ACCEPT_CERTIFICATE",

	VIEW_CONFIG_WORKFLOW: "VIEW_CONFIG_WORKFLOW",
	EDIT_CONFIG_WORKFLOW: "EDIT_CONFIG_WORKFLOW",

	VIEW_WORKFLOW: "VIEW_WORKFLOW",
	ADD_WORKFLOW: "ADD_WORKFLOW",
	EDIT_WORKFLOW: "EDIT_WORKFLOW",
	DELETE_WORKFLOW: "DELETE_WORKFLOW",
	IMPORT_WORKFLOW: "IMPORT_WORKFLOW",
	EXPORT_WORKFLOW: "EXPORT_WORKFLOW",
	ACCEPT_WORKFLOW: "ACCEPT_WORKFLOW",
};
